import src from "IMAGE";
export default { src, width: 521, height: 478, blurWidth: 0, blurHeight: 0};
